/* LINTEL storefront: cart drawer, add to cart, gallery, menu, sticky bar */
(function () {
  var drawer = document.getElementById('oak-drawer');
  var inner = document.getElementById('oak-cart-inner');
  var menu = document.getElementById('oak-menu');

  window.__lntOpen = function () { return openDrawer.apply(this, arguments); }; function openDrawer() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  function refresh() {
    return fetch('/?sections=oak-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['oak-cart-drawer'] || '';
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var sec = tmp.firstElementChild;
        inner.innerHTML = sec ? sec.innerHTML : html;
        var body = inner.querySelector('[data-oak-n]');
        var n = body ? body.getAttribute('data-oak-n') : '0';
        document.querySelectorAll('[data-oak-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-n', n); });
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-oak-open],[data-oak-close],[data-oak-menu],[data-oak-qty]');
    if (!t) return;
    if (t.hasAttribute('data-oak-open')) { e.preventDefault(); refresh().then(openDrawer); }
    else if (t.hasAttribute('data-oak-close')) { closeDrawer(); }
    else if (t.hasAttribute('data-oak-menu')) { menu.classList.toggle('is-open'); }
    else if (t.hasAttribute('data-oak-qty')) {
      t.disabled = true;
      fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: t.getAttribute('data-oak-qty'), quantity: parseInt(t.getAttribute('data-q'), 10) }) })
        .then(refresh);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  document.querySelectorAll('form[data-oak-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var label = btn.innerHTML; btn.disabled = true; btn.innerHTML = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () { return refresh(); })
        .then(function () { btn.disabled = false; btn.innerHTML = label; openDrawer(); })
        .catch(function () { btn.disabled = false; btn.innerHTML = label; form.submit(); });
    });
  });
  document.querySelectorAll('[data-oak-buy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var f = document.querySelector('form[data-oak-add]');
      if (f) f.requestSubmit ? f.requestSubmit() : f.querySelector('[type=submit]').click();
    });
  });

  var gal = document.querySelector('[data-oak-gal]');
  var galShow = null, galFilter = null;
  if (gal) {
    var imgs = Array.prototype.slice.call(gal.querySelectorAll('.oak-gal__main img'));
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.oak-gal__thumbs button'));
    var dotsBox = gal.querySelector('.oak-gal__dots');
    var vis = [], cur = 0;
    galShow = function (i) {
      if (!vis.length) return;
      cur = (i + vis.length) % vis.length;
      imgs.forEach(function (el, k) { el.classList.toggle('is-on', k === vis[cur]); });
      thumbs.forEach(function (el, k) { el.classList.toggle('is-on', k === vis[cur]); });
      dotsBox.querySelectorAll('span').forEach(function (d, k) { d.classList.toggle('is-on', k === cur); });
    };
    galFilter = function (colour) {
      vis = [];
      imgs.forEach(function (el, k) {
        var c = el.getAttribute('data-col');
        var ok = !colour || c === colour || c === 'All';
        el.hidden = !ok; thumbs[k].hidden = !ok;
        if (ok) vis.push(k);
      });
      dotsBox.innerHTML = vis.map(function () { return '<span></span>'; }).join('');
      dotsBox.querySelectorAll('span').forEach(function (d, k) { d.addEventListener('click', function () { galShow(k); }); });
      galShow(0);
    };
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { var i = vis.indexOf(k); if (i > -1) galShow(i); }); });
    gal.querySelectorAll('[data-dir]').forEach(function (b) { b.addEventListener('click', function () { galShow(cur + parseInt(b.dataset.dir, 10)); }); });
    var main = gal.querySelector('.oak-gal__main'), x0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) galShow(cur + (dx < 0 ? 1 : -1)); x0 = null;
    });
  }

  var swatches = document.querySelectorAll('[data-oak-variant]');
  function pickVariant(btn, push) {
    var colour = btn.getAttribute('data-colour');
    swatches.forEach(function (s) { var on = s === btn; s.classList.toggle('is-on', on); s.setAttribute('aria-checked', on ? 'true' : 'false'); });
    var idInput = document.querySelector('[data-oak-id]'); if (idInput) idInput.value = btn.getAttribute('data-oak-variant');
    document.querySelectorAll('[data-oak-colour-name]').forEach(function (el) { el.textContent = colour; });
    var now = document.querySelector('.oak-buy .oak-price__now'); if (now) now.textContent = btn.getAttribute('data-price');
    var was = document.querySelector('.oak-buy .oak-price__was'); if (was) was.textContent = btn.getAttribute('data-compare');
    var sp = document.querySelector('[data-oak-sticky-price]'); if (sp) sp.textContent = btn.getAttribute('data-price');
    var submit = document.querySelector('form[data-oak-add] [type=submit]');
    if (submit) { var av = btn.getAttribute('data-available') === 'true'; submit.disabled = !av; submit.textContent = av ? 'Add to cart' : 'Sold out'; }
    if (galFilter) galFilter(colour);
    if (push && window.history && history.replaceState) {
      var u = new URL(location.href); u.searchParams.set('variant', btn.getAttribute('data-oak-variant')); history.replaceState(null, '', u.toString());
    }
  }
  swatches.forEach(function (b) { b.addEventListener('click', function () { pickVariant(b, true); }); });
  var onSw = document.querySelector('[data-oak-variant].is-on');
  if (onSw) pickVariant(onSw, false); else if (galFilter) galFilter(null);

  document.querySelectorAll('[data-oak-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var inp = document.querySelector('[data-oak-qtyinput]');
      var n = Math.max(1, Math.min(20, (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-oak-step'), 10)));
      inp.value = n;
    });
  });

  var sticky = document.querySelector('.oak-sticky'), atc = document.querySelector('form[data-oak-add] [type=submit]');
  if (sticky && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var r = en[0]; sticky.classList.toggle('is-on', !r.isIntersecting && r.boundingClientRect.top < 0);
    }).observe(atc);
  }
})();

/* ===== 10-02 (Edvin): Add to cart NEVER goes to /cart - every add (theme ATC, Kaching ATC, any /cart/add form) opens the __LNT_NONE brand cart drawer ===== */
(function () {
  if (window.__oak_atc) return; window.__oak_atc = 1;
  function open() { if (window.__LNT_NONE && window.__LNT_NONE.openCart) return window.__LNT_NONE.openCart(); if (window.__lntOpen) return window.__lntOpen(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 2) return setTimeout(add, 800); /* 10-06: bot check (429) or network -> normal form POST, back to this page (?opencart=1), drawer opens. Never /cart, never an alert */ try { var u = new URL(location.href); u.searchParams.set('opencart', '1'); var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = u.pathname + u.search; f.appendChild(h); } catch (x) {} HTMLFormElement.prototype.submit.call(f); });
    })();
  }, false);
})();

/* 10-06: back from the fallback POST (?opencart=1) -> open the brand cart drawer and clean the URL */
(function () {
  try { var u = new URL(location.href); if (u.searchParams.get('opencart') !== '1') return; u.searchParams.delete('opencart'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { return; }
  var n = 0, t = setInterval(function () { var ok = false; for (var k in window) { if (/^[A-Z]{2,4}$/.test(k) && window[k] && typeof window[k].openCart === 'function') { window[k].openCart(); ok = true; break; } } if (!ok && window.__lntOpen) { window.__lntOpen(); ok = true; } if (ok || ++n > 40) clearInterval(t); }, 150);
})();
